export default "__VITE_ASSET__dd401b44__"